<!-- <div class="no_data_component" [ngClass]="{'horizontal_layout': !isVerticalImg}">
<div class="no_data_text">
  <div class="horizontal_img" *ngIf="showImg && !isVerticalImg" [style.height.px]="(imgContainerheight)"><img src="{{imgPath}}"></div>
  <div [ngClass]="{'horizontal_text': !isVerticalImg}">
    <h1 class="font-14 m-0 font-weight-normal">{{headerTitle}}</h1>
    <div *ngIf="showDesc" class="font-13 mt-15 text-muted">{{description}}</div>
  </div>
</div>
<div class="vertical_img" *ngIf="showImg && isVerticalImg" [style.height.px]="(imgContainerheight)">
  <img src="{{imgPath}}" [style.height.px]="(imgContainerheight)">
  <div class="onHoverAdd" *ngIf="showAddBtn">
    <i class="fn-global-add white cursor-pointer" (click)="addAction()"></i>
  </div>
</div>
</div> -->
<div class="no_data_component" [ngClass]="{'horizontal_layout': !isVerticalImg}"  [style.height.px]="(imgContainerheight)">
  @if (showImg) {
    <div class="vertical_img">
      <img src="{{imgPath}}"/>
      @if (showAddBtn) {
        <div class="onHoverAdd">
          <i class="fn-global-add white cursor-pointer" (click)="addAction()"></i>
        </div>
      }
    </div>
  }
  <div class="no_data_text">
    <h1 class="m-0">{{headerTitle}}</h1>
    @if (showDesc) {
      <div class="mt-5 text-muted">{{description}}</div>
    }
  </div>
</div>